import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import emitter from '../utils/emitter';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        emitter.on('carnetContent', (posts) => {
            let total = posts.length;
            this.el.innerHTML = total;
        });
    }
}